import { useState, useRef } from "react";
import { PositionItemsInOrder } from "../../../refractCommon/miro/PositionItemsInOrder";

const { board } = window.miro;

export default function SortByGeometry({ boardSelection }) {
  const [ascendLeft, setAscendLeft] = useState(true);
  const [ascendRight, setAscendRight] = useState(false);
  const [toolOpen, setToolOpen] = useState(false);
  const [setHeight, setHeightState] = useState("0px");
  const content = useRef(null);

  function handleToggleOpen() {
    setToolOpen(!toolOpen);
    setHeightState(toolOpen ? "0px" : `${content?.current?.scrollHeight}px`);
  }

  let sortByGeometryTypeIcons = (
    <div className="cs5 ce12 grid">
      <div className="m2 icon icon-sticky-bulk cs1"></div>
      <div className="m2 icon icon-rectangle cs2"></div>
      <div className="m2 icon icon-card cs3"></div>
      <div className="m2 icon icon-text cs4"></div>
      <div className="m2 icon icon-image cs5"></div>
      <div className="m2 icon icon-frame cs6"></div>
    </div>
  );

  function runSelectItemsForScale(selection) {
    let filteredSelection = selection.filter(
      (item) =>
        (item.type === "sticky_note" && item.parentId === null) ||
        (item.type === "text" && item.parentId === null) ||
        (item.type === "card" && item.parentId === null) ||
        (item.type === "shape" && item.parentId === null) ||
        (item.type === "frame" && item.childrenIds.length === 0) ||
        (item.type === "image" && item.parentId === null)
    );

    return filteredSelection;
  }

  async function runSortGeometry(flag) {
    let selection = await board.getSelection();
    let filteredSelection = runSelectItemsForScale(selection);
    let updateArray = [];
    if (flag === "width") {
      updateArray = runSortByWidth(filteredSelection);
    }
    if (flag === "height") {
      updateArray = runSortByHeight(filteredSelection);
    }
    if (flag === "area") {
      updateArray = runSortByArea(filteredSelection);
    }

    await PositionItemsInOrder(updateArray);
  }

  function runSortByWidth(itemArray) {
    if (ascendRight) {
      return itemArray.sort((a, b) => a.width - b.width);
    } else {
      return itemArray.sort((a, b) => b.width - a.width);
    }
    // if ascendRight
    // run the sort to get the array ordering smallest to largest
    // else
    // run the sort to get the array ordering largest to smallest
    // then run the positioning, whereby the x-step at each interval is "last-width" referencing the last itmes width.
  }
  function runSortByHeight(itemArray) {
    if (ascendRight) {
      return itemArray.sort((a, b) => a.height - b.height);
    } else {
      return itemArray.sort((a, b) => b.height - a.height);
    }
    // if ascendRight
    // run the sort to get the array ordering smallest to largest
    // else
    // run the sort to get the array ordering largest to smallest
    // then run the positioning, whereby the x-step at each interval is "last-width"  referencing the last itmes width.
  }
  function runSortByArea(itemArray) {
    if (ascendRight) {
      return itemArray.sort((a, b) => a.height * a.width - b.height * b.width);
    } else {
      return itemArray.sort((a, b) => b.height * b.width - a.height * a.width);
    }
    // if ascendRight
    // run the sort to get the array ordering smallest to largest
    // else
    // run the sort to get the array ordering largest to smallest
    // then run the positioning, whereby the x-step at each interval is "last-width" referencing the last itmes width.
  }

  return (
    <div id="sort-by-geometry-tool" className="grid tool-section mt-0 pb-0">
      <div
        id="sort-by-geometry-tool-header"
        className={"grid cs1 ce12 mt-0 cursor-pointer mb-0"}
        onClick={(event) => {
          handleToggleOpen();
        }}>
        <div className="cs1 icon m2 icon-triangle mt-0 mb-0"></div>
        <div className="h3 cs2 ce11 mt-0 mb-0">Geometry</div>
        <div
          className={
            "cs12 icon m2 mb-0 mt-0 cursor-pointer" +
            " " +
            (toolOpen === false ? " icon-arrow-right" : " icon-arrow-down")
          }></div>
      </div>

      <div
        id="accordion-content"
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="cs1 ce12 grid accordion mt-0 ">
        <div id="accordion-margin" className="cs1 ce12 grid pb-8">
          <p className="p-medium mt-0 pt-0 cs1 ce12 mb-0">
            Sort items by width, height attributes. Items
          </p>
          <div
            id="sort-by-geometry-works-on"
            className="help-container grid cs1 ce12 mt-0 mb-8 pt-8">
            <p className="p-small cs1 ce4 mb-0 mt-0">
              Works on
              <b> many:</b>
            </p>
            {sortByGeometryTypeIcons}
          </div>
          <label className="radiobutton cs1 ce5 mt-0 mb-8">
            <input
              type="radio"
              tabIndex="0"
              defaultValue="0"
              name="Ascend Left Geometry"
              checked={ascendLeft}
              onChange={() => {
                setAscendLeft(!ascendLeft);
                setAscendRight(ascendLeft);
              }}
            />
            <span>Ascend Left</span>
          </label>
          <label className="radiobutton cs6 ce12 mt-0 mb-8">
            <input
              type="radio"
              tabIndex="0"
              defaultValue="0"
              name="Ascend Right Geometry"
              checked={ascendRight}
              onChange={() => {
                setAscendRight(!ascendRight);
                setAscendLeft(ascendRight);
              }}
            />
            <span>Ascend Right</span>
          </label>

          <div
            type="button"
            className="button button-secondary button-small cs1 ce4 mb-0 fix-stupid-button"
            onClick={() => runSortGeometry("width")}>
            Width
          </div>
          <div
            type="button"
            className="button button-secondary button-small cs5 ce8 mb-0 fix-stupid-button"
            onClick={() => runSortGeometry("height")}>
            Height
          </div>
          <div
            type="button"
            className="button button-secondary button-small cs9 ce12 mb-0 fix-stupid-button"
            onClick={() => runSortGeometry("area")}>
            Area
          </div>
        </div>
      </div>
    </div>
  );
}
